var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_47568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.13401 4.13401 0 8 0H42C45.866 0 49 3.13401 49 7V41C49 44.866 45.866 48 42 48H8C4.13401 48 1 44.866 1 41V7Z",
    fill: "#DBF0DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28C29.1667 28 28.4583 27.7083 27.875 27.125C27.2917 26.5417 27 25.8333 27 25C27 24.1667 27.2917 23.4583 27.875 22.875C28.4583 22.2917 29.1667 22 30 22C30.8333 22 31.5417 22.2917 32.125 22.875C32.7083 23.4583 33 24.1667 33 25C33 25.8333 32.7083 26.5417 32.125 27.125C31.5417 27.7083 30.8333 28 30 28ZM24 35V32.1C24 31.75 24.0833 31.4208 24.25 31.1125C24.4167 30.8042 24.65 30.5583 24.95 30.375C25.4833 30.0583 26.0458 29.7958 26.6375 29.5875C27.2292 29.3792 27.8333 29.225 28.45 29.125L30 31L31.55 29.125C32.1667 29.225 32.7667 29.3792 33.35 29.5875C33.9333 29.7958 34.4917 30.0583 35.025 30.375C35.325 30.5583 35.5625 30.8042 35.7375 31.1125C35.9125 31.4208 36 31.75 36 32.1V35H24ZM22 32.1V33H18C17.45 33 16.9792 32.8042 16.5875 32.4125C16.1958 32.0208 16 31.55 16 31V17C16 16.45 16.1958 15.9792 16.5875 15.5875C16.9792 15.1958 17.45 15 18 15H32C32.55 15 33.0208 15.1958 33.4125 15.5875C33.8042 15.9792 34 16.45 34 17V22C33.4833 21.35 32.9 20.8542 32.25 20.5125C31.6 20.1708 30.85 20 30 20V19H20V21H27C26.6667 21.2667 26.3667 21.5667 26.1 21.9C25.8333 22.2333 25.6083 22.6 25.425 23H20V25H25C25 25.35 25.0375 25.6917 25.1125 26.025C25.1875 26.3583 25.2917 26.6833 25.425 27H20V29H23.45C23 29.3833 22.6458 29.8458 22.3875 30.3875C22.1292 30.9292 22 31.5 22 32.1Z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_47568",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_47568"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_47568",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhricon);
export default __webpack_public_path__ + "static/media/ehr+icon.fe035feec378d77d86de6ea1cdf52050.svg";
export { ForwardRef as ReactComponent };